import Main from '@/views/administracion/configuracion/catalogos/municipios/Main.vue';
import Default from '@/views/administracion/configuracion/catalogos/municipios/Default.vue';

const auth = ['Catálogos:ver'];
const scopes = ['Catálogos:crear', 'Catálogos:editar', 'Catálogos:eliminar'];

const municipios = [
  {
    path: 'municipios',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'catalogoMunicipios',
        path: '/',
        meta: {
          title: 'Municipios',
          auth,
          scopes,
        },
        component: Default,
      },
    ],
  },
];

export default municipios;
